import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import { RecommendedSessionCard } from "../RecommendedSessionCard";
import type { RecommendedAction } from "./types";

type Props = {
	actions: RecommendedAction[];
	selectedId?: string;
	disabled?: boolean;
	helperText?: string;
	emptyText?: string;
	onSelect: (id: string) => void;
};

const RecommendedActionsList = ({
	actions,
	selectedId,
	disabled,
	helperText,
	emptyText,
	onSelect,
}: Props) => {
	const theme = useAppTheme();

	return (
		<Box gap={16} alignItems="stretch">
			{actions.length > 0 ? (
				actions.map((action) => (
					<RecommendedSessionCard
						key={action.id}
						icon={action.icon}
						title={action.title}
						subtitle={action.subtitle}
						chips={
							action.badge
								? [
										{
											icon: action.badge.icon ?? "clock-outline",
											label: action.badge.label,
										},
									]
								: undefined
						}
						selected={action.id === selectedId}
						disabled={disabled}
						onPress={() => onSelect(action.id)}
					/>
				))
			) : (
				<Box paddingVertical={24}>
					<Text
						variant="bodyMedium"
						style={{
							color: theme.colors.onSurfaceVariant,
							textAlign: "center",
						}}
					>
						{emptyText}
					</Text>
				</Box>
			)}
			{actions.length > 0 && !selectedId && helperText ? (
				<Text
					variant="bodyMedium"
					style={{
						color: theme.colors.onSurfaceVariant,
						textAlign: "center",
					}}
				>
					{helperText}
				</Text>
			) : null}
		</Box>
	);
};

export default RecommendedActionsList;
